var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.25 144.578H23.75C10.6543 144.578 0 133.924 0 120.828C0 107.732 10.6543 97.0781 23.75 97.0781H128.25C141.346 97.0781 152 107.732 152 120.828C152 133.924 141.346 144.578 128.25 144.578Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1562 128.25C65.2552 128.25 68.5781 124.927 68.5781 120.828C68.5781 116.729 65.2552 113.406 61.1562 113.406C57.0573 113.406 53.7344 116.729 53.7344 120.828C53.7344 124.927 57.0573 128.25 61.1562 128.25Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4688 128.25C35.5677 128.25 38.8906 124.927 38.8906 120.828C38.8906 116.729 35.5677 113.406 31.4688 113.406C27.3698 113.406 24.0469 116.729 24.0469 120.828C24.0469 124.927 27.3698 128.25 31.4688 128.25Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8125 46.6094H58.1875C55.7282 46.6094 53.7344 44.6156 53.7344 42.1562V29.6875C53.7344 17.4102 63.7227 7.42188 76 7.42188C88.2773 7.42188 98.2656 17.4102 98.2656 29.6875V42.1562C98.2656 44.6156 96.2718 46.6094 93.8125 46.6094ZM62.6406 37.7031H89.3594V29.6875C89.3594 22.3211 83.3664 16.3281 76 16.3281C68.6336 16.3281 62.6406 22.3211 62.6406 29.6875V37.7031Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76 7.42188V16.3281C83.3664 16.3281 89.3594 22.3211 89.3594 29.6875V37.7031H76V46.6094H93.8125C96.2718 46.6094 98.2656 44.6156 98.2656 42.1562V29.6875C98.2656 17.4102 88.2773 7.42188 76 7.42188Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.203 81.9375H47.7969C45.3376 81.9375 43.3438 79.9437 43.3438 77.4844V42.1562C43.3438 39.6969 45.3376 37.7031 47.7969 37.7031H104.203C106.662 37.7031 108.656 39.6969 108.656 42.1562V77.4844C108.656 79.9437 106.662 81.9375 104.203 81.9375Z",
    fill: "#67CB85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.203 37.7031H76V81.9375H104.203C106.662 81.9375 108.656 79.9437 108.656 77.4844V42.1562C108.656 39.6969 106.662 37.7031 104.203 37.7031Z",
    fill: "#5C3069"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4219 57C83.4219 54.5407 81.4281 52.5469 78.9688 52.5469H73.0312C70.5719 52.5469 68.5781 54.5407 68.5781 57C68.5781 58.938 69.8185 60.5824 71.5469 61.1943V62.9375C71.5469 65.3968 73.5407 67.3906 76 67.3906C78.4593 67.3906 80.4531 65.3968 80.4531 62.9375V61.1943C82.1815 60.5824 83.4219 58.938 83.4219 57Z",
    fill: "#5C3069"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.25 97.0781H76V144.578H128.25C141.346 144.578 152 133.924 152 120.828C152 107.732 141.346 97.0781 128.25 97.0781Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8438 128.25C94.9427 128.25 98.2656 124.927 98.2656 120.828C98.2656 116.729 94.9427 113.406 90.8438 113.406C86.7448 113.406 83.4219 116.729 83.4219 120.828C83.4219 124.927 86.7448 128.25 90.8438 128.25Z",
    fill: "#666666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.531 128.25C124.63 128.25 127.953 124.927 127.953 120.828C127.953 116.729 124.63 113.406 120.531 113.406C116.432 113.406 113.109 116.729 113.109 120.828C113.109 124.927 116.432 128.25 120.531 128.25Z",
    fill: "#666666"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9688 52.5469H76V67.3906C78.4593 67.3906 80.4531 65.3968 80.4531 62.9375V61.1943C82.1815 60.5824 83.4219 58.938 83.4219 57C83.4219 54.5407 81.4281 52.5469 78.9688 52.5469Z",
    fill: "#67CB85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword1);
export default __webpack_public_path__ + "static/media/password 1.919b92164783e1159c7223d9b2c47efe.svg";
export { ForwardRef as ReactComponent };